// Every file type the app supports. Folders hold mixed media, so this is the
// single upload gate on the client - the backend enforces the same list in
// addResource. Keep in sync with GLOBAL_ALLOWED_FILE_TYPES in
// functions/src/config/defaultShowFolders.ts.
export const GLOBAL_ALLOWED_FILE_TYPES = [
  'MP3', 'WAV', 'M4A',
  'MP4', 'MOV', 'AVI',
  'PDF', 'DOC', 'DOCX', 'PNG', 'JPG',
];

// Extensions accepted by file inputs. JPEG is an alias of JPG.
export const GLOBAL_ALLOWED_EXTENSIONS = [
  ...GLOBAL_ALLOWED_FILE_TYPES,
  'JPEG',
];

// accept= attribute value for <input type="file">
export const GLOBAL_FILE_ACCEPT = GLOBAL_ALLOWED_EXTENSIONS
  .map(type => `.${type.toLowerCase()}`)
  .join(',');
